<template>
  <fields-group :label="label">
    <v-row
      v-for="(item, key) in items"
      :key="`sources-${key}-${getHash(item)}`"
    >
      <v-col cols="12" sm="5">
        <v-select
          v-model="items[key].id"
          :items="sources"
          label="Источник"
          item-text="name"
          item-value="id"
          outlined
          required
          :loading="loading || isSourcesFetching"
          :rules="sourceSelectRule"
        />
      </v-col>

      <v-col cols="12" sm="7">
        <div class="d-flex">
          <v-autocomplete
            v-model="items[key].priceListId"
            class="mr-6"
            :items="getPriceLists"
            label="Прайс-лист"
            item-text="name"
            item-value="id"
            outlined
            required
            :loading="loading || isPriceListsFetching"
          />
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="accent"
                elevation="1"
                icon
                small
                class="mb-2 mt-3"
                v-bind="attrs"
                v-on="on"
                @click="deleteItem(item, key)"
              >
                <font-awesome-icon icon="times" />
              </v-btn>
            </template>
            <span>Удалить</span>
          </v-tooltip>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="3">
        <v-btn :loading="loading" block @click="addItem">
          Добавить
        </v-btn>
      </v-col>
    </v-row>
  </fields-group>
</template>

<script>
  import FieldsGroup from '@/components/ui/FieldsGroup.vue'
  import md5 from 'md5'
  import rules from '@/mixins/rules'
  import SourceDataService from '@/services/api/SourceDataService'
  import { mapGetters } from 'vuex'

  export default {
    name: 'SourcesField',
    components: { FieldsGroup },
    mixins: [rules],
    props: {
      value: {
        type: Array,
        default: () => [],
      },
      label: {
        type: String,
        default: 'Источники',
      },
      createEntity: {
        type: Boolean,
        default: false,
      },
      loading: Boolean,
    },
    data () {
      return {
        isSourcesFetching: false,
        isPriceListsFetching: false,
        sources: [],
        sourceSelectRule: [(value) => !!value || 'Обязательное поле'],
      }
    },
    computed: {
      ...mapGetters({
        getPriceLists: 'priceList/getPriceLists',
      }),
      items: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        },
      },
    },
    created () {
      this.fetchSources().then(() => this.addMissingRequiredSources())
      this.fetchPriceLists()
    },
    methods: {
      async fetchSources () {
        this.isSourcesFetching = true
        try {
          this.sources = await SourceDataService.getList()
        } catch (error) {
          this.showErrorFromResponse(error)
        } finally {
          this.isSourcesFetching = false
        }
      },
      async fetchPriceLists () {
        this.isPriceListsFetching = true
        try {
          await this.$store.dispatch('priceList/fetchPriceLists', {
            limit: 100000,
            offset: 0,
            page: 1,
          })
        } catch (error) {
          this.showErrorFromResponse(error)
        } finally {
          this.isPriceListsFetching = false
        }
      },
      addMissingRequiredSources () {
        this.sources.forEach((source) => {
          if (
            source.requiredForAllFilials &&
            !this.items.find((item) => item.id === source.id)
          ) {
            this.items.push({
              id: source.id,
              requiredForAllFilials: source.requiredForAllFilials,
              priceListId: null,
            })
          }
        })
      },
      getHash (item) {
        return md5(item)
      },
      addItem () {
        this.$emit('input', [...this.items, { id: null, priceListId: null }])
      },
      deleteItem (item, key) {
        if (item.requiredForAllFilials && this.items.filter(i => i.id === item.id).length === 1) {
          this.showErrorMessage('Источник обязателен')
        } else {
          this.items = this.items.toSpliced(key, 1)
        }
      },
    },
  }
</script>

<style scoped lang="less"></style>
